import { RTJS_lightbox } from '@rtsoft/rtjs';

document.addEventListener('DOMContentLoaded', () => {
    RTJS_lightbox('.lightbox');
});
